module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.9882/images/hands/hands@2x.svg"